// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2aIod","fileDisabled":"File_fileDisabled__1JW65"};